// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___KkN4","type":"styles_type__3xwzL","choices":"styles_choices__3qiHZ"};